import React from 'react';

// Hooks
import { useState } from 'react';

const GlobalModalContext = React.createContext<{
    element: React.ReactNode | null, setElement: React.Dispatch<React.SetStateAction<React.ReactNode | null>>,
}
>({
    element: null, setElement: () => undefined
});

export const GlobalModalContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    const [element, setElement] = useState<null | React.ReactNode>(null);

    const initState = {
        element, setElement
    };

    return (
        <GlobalModalContext.Provider value={initState}>
            <>
                <div className='modalGlobal' style={ {display: element !== null ? 'block' : 'none'}}>
                    {element}
                </div>
                {children}
            </>
        </GlobalModalContext.Provider>
    );
};
export default GlobalModalContext;
